import { plansData } from "../../data/plansData";
import whiteTick from "../../assets/whiteTick.png";
import "./Plans.css";
import { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-scroll";

const Plans = () => {
  const [cards, setCards] = useState([
    { id: 1, isFlip: false },
    { id: 2, isFlip: false },
    { id: 3, isFlip: false },
    // ...
  ]);

  const generateKey = () => {
    let key = Math.floor(Math.random() * 90000) + 10000;
    return key;
  };

  const handleFlip = (cardId) => {
    setCards((plansData) =>
      plansData.map((card, i) =>
        i === cardId ? { ...card, isFlip: !card.isFlip } : card
      )
    );
    // console.log(cardId);
  };

  useEffect(() => {
    let qr = [];
    qr[0] = new Image();
    qr[0].src = plansData[2].payment.qrCode[0].img;
    qr[1] = new Image();
    qr[1].src = plansData[2].payment.qrCode[1].img;
    qr[2] = new Image();
    qr[2].src = plansData[2].payment.qrCode[2].img;
    qr[3] = new Image();
    qr[3].src = plansData[2].payment.qrCode[3].img;
    qr[4] = new Image();
    qr[4].src = plansData[2].payment.qrCode[4].img;
    // console.log(cards);
    handleFlip();
  }, []);

  const [currentIndex, setCurrentIndex] = useState(1);
  const handlePrevious = (len) => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? len - 1 : prevIndex - 1));
  };

  const handleNext = (len) => {
    setCurrentIndex((prevIndex) => (prevIndex === len - 1 ? 0 : prevIndex + 1));
  };

  return (
    <div className="plans-container" id="plans">
      <div className="blur plans-blur-1"></div>
      <div className="blur plans-blur-2"></div>
      <div className="programs-header" style={{ gap: "2rem" }}>
        <span className="stroke-text">READY TO START</span>
        <span>YOUR JOURNEY</span>
        <span className="stroke-text">NOW WITHUS</span>
      </div>
      {/* plains card */}
      <div className="plans">
        {plansData.map((plan, i) => {
          return (
            <div className="container" key={i}>
              <div
                className={`plan ${cards[i].isFlip ? "plan-flip" : ""}`}
                key={i}
              >
                {plan.icon}
                <span>{plan.name}</span>
                <span>₹{plan.price}</span>
                <div className="features">
                  {plan.features.map((feature, i) => {
                    return (
                      <div className="feature" key={generateKey()}>
                        <img src={whiteTick} alt="" />
                        <span>{feature}</span>
                      </div>
                    );
                  })}
                </div>
                <div className="details">
                  <Link
                    activeClass="active"
                    to="programs"
                    spy={true}
                    smooth={true}
                    offset={-40}
                    duration={500}
                  >
                    See more benefits {"->"}
                  </Link>
                </div>
                <button
                  className="btn"
                  onClick={() => {
                    handleFlip(i);
                  }}
                >
                  <span>Join now</span>
                </button>
                <div className="plan-back">
                  <div className="qrCodes-container">
                    {/* {plan.payment &&
                        plan.payment.qrCode.map((qr, i) => {
                          return (
                            <div key={i} className="qrCodes">
                              <img src={qr} alt="img" />
                            </div>
                          )
                        })} */}

                    <img
                      src={
                        plan.payment.qrCode.length === 1
                          ? plan.payment.qrCode[0].img
                          : plan.payment.qrCode[currentIndex].img
                      }
                      alt="img"
                    />
                    <span>
                      {plan.payment.qrCode.length === 1
                        ? plan.payment.qrCode[0].price
                        : plan.payment.qrCode[currentIndex].price}
                    </span>
                  </div>
                  <div className="instructions">
                    {plan.payment &&
                      plan.payment.instructions.map((info, i) => {
                        return (
                          <div
                            key={generateKey()}
                            className="instructions-info"
                          >
                            <span>
                              {i + 1}. {info}
                            </span>
                          </div>
                        );
                      })}
                  </div>
                  {/* {plan.payment ? plan.payment.instructions : ""} */}
                </div>
              </div>
              <span
                key={generateKey()}
                className={`${cards[i].isFlip ? "back-btn" : "back-btn-flip"}`}
                onClick={() => {
                  handleFlip(i);
                }}
              >
                {"<-"} Back
              </span>
              {plan.payment.qrCode.length > 1 && cards[i].isFlip && (
                <div
                  className={`${
                    cards[i].isFlip ? "all-qrcode" : "all-qrcode-flip"
                  }`}
                >
                  <button
                    onClick={() => handlePrevious(plan.payment.qrCode.length)}
                    className="qr-change-btn1"
                  >
                    Previous
                  </button>
                  <button
                    onClick={() => handleNext(plan.payment.qrCode.length)}
                    className="qr-change-btn2"
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Plans;
